module.exports = __webpack_public_path__ + "img/BSlinger64_ua.5e080954.webp";